import React, {
  ChangeEvent,
} from 'react';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from 'pages/Dashboard/components/Input/Radio';
import clsx from 'clsx';
import {
  IntakeQuestionnaireOptions,
} from 'dtos';

type Props = {
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  value: string;
  isLoading?: boolean;
  onClose: () => void;
  onSameValueSelected?: () => void;
  options?: IntakeQuestionnaireOptions[];
};

export default function IntakeQustionnaireType({
  value,
  isLoading,
  onClose,
  onSameValueSelected,
  options,
  ...props
}: Props) {
  return (
    <RadioGroup
      {...props}
      value={value}
      className="p-0 w-full flex justify-between border border-gray-200 rounded"
    >
      {options?.map((option) => (
        <Radio
          key={option.value}
          value={option?.value ?? ''}
          onClick={(e) => {
            e.stopPropagation();
            if (value === option.value) {
              onSameValueSelected?.();
            }
          }}
          label={(
            <div className="flex flex-col w-full cursor-pointer">
              <p className="font-semibold">{option?.name ?? ''}</p>
              <span className="text-[10px] whitespace-normal break-words">{option.description ?? ''}</span>
            </div>
          )}
          className={clsx(
            'text-xs min-h-[60px] !ml-0 px-1.5 py-2 border-b border-gray-200 rounded-none last:border-b-0',
            'focus-visible:outline',
            {
              '!bg-blue-50': option.value === value,
              'cursor-wait': isLoading,
            },
          )}
          size="small"
          classes={{
            checked: '!text-blue-500',
          }}
        />
      ))}
    </RadioGroup>
  );
}
